const hyphenToCamelCase = (input: string): string => {
  let result = input
    .replace(/(\w{8}-\w{4}-\w{4}-\w{4}-\w{12})/g, '')
    .replace(/^\//, '')
    .replace(/\//g, '.')
    .replace(/-([a-z])/g, (_, match) => match.toUpperCase())

  if (result.endsWith('.')) {
    result = result.slice(0, -1)
  }
  if (result.endsWith('adminSettings')) {
    result += '.general'
  }
  if (result.endsWith('users')) {
    result += '.users'
  }
  if (result.endsWith('demands')) {
    result += '.demands'
  }
  if (result.endsWith('candidates')) {
    result += '.candidates'
  }
  result = result.replace(/\.{2,}/g, '.');
  return result;
}

export default hyphenToCamelCase